import React from 'react'
import { Tabs } from '../../../../../../../common/tabs'
import { SCORE_TABS } from './constants'
import s from './index.module.scss'

const Filter = ({ sortBy, setSortBy }) => {
  const onChange = (key) => {
    setSortBy(key)
  }
  return (
    <div className={s.tabs}>
      <Tabs
        isI18n
        activeKey={sortBy}
        onChange={onChange}
        items={Object.values(SCORE_TABS)}
        getAppendStyleItem={(key) => {
          const defaultStyle = {
            backgroundColor: '#F3F3F3',
            padding: '2px 8px',
          }

          if (key) {
            return {
              ...defaultStyle,
              backgroundColor: '#2C73E8',
              color: '#FFFFFF',
            }
          }

          return defaultStyle
        }}
      />
    </div>
  )
}

export default Filter
